import * as React from 'react';
import { Field, Form, FormSpy } from 'react-final-form';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Typography from './modules/components/Typography';
import AppFooter from './modules/views/AppFooter';
import AppAppBar from './modules/views/AppAppBar';
import AppForm from './modules/views/AppForm';
import { email, required } from './modules/form/validation';
import RFTextField from './modules/form/RFTextField';
import FormButton from './modules/form/FormButton';
import FormFeedback from './modules/form/FormFeedback';
import withRoot from './modules/withRoot';
import axios from "axios";
import { API_BASE_URL, API_SIGN_UP_PATH, UI_SIGN_IN_PATH, TIME_DELAY_MSEC, API_TOKEN_PATH } from './consts';
import { useNavigate } from "react-router-dom"
import Snackbar from './modules/components/Snackbar';


function SignIn() {
  const [open, setOpen] = React.useState(true);
  const handleClose = () => {
    setOpen(false);
  };
  const [sent, setSent] = React.useState(false);

  const validate = (values: { [index: string]: string }) => {
    const errors = required(['email', 'password'], values);

    if (!errors.email) {
      const emailError = email(values.email);
      if (emailError) {
        errors.email = emailError;
      }
    }

    return errors;
  };

  const navigation = useNavigate()

  const [clientMessage, setClientMessage] = React.useState('')


  // const [useremail, setEmail] = React.useState("");
  // const [password, setPassword] = React.useState("");

  // const handleChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setEmail(e.target.value)
  // }

  // e: React.ChangeEvent<HTMLInputElement>
  const handleLogin = async (email: string, password: string) => {
    // e.preventDefault();



    try {
      const user = {
        email: email,
        password: password
      };
      // Create the POST requuest
      const response = await
        axios.post(
          `${API_BASE_URL}${API_TOKEN_PATH}`,
          user, {
          headers:
            { 'Content-Type': 'application/json' },
          withCredentials: true
        });

      //Initialize the access & refresh token in localstorage.


      if (response.status === 200) {
        localStorage.clear();
        localStorage.setItem('access_token', response.data.access);
        localStorage.setItem('refresh_token', response.data.refresh);
        axios.defaults.headers.common['Authorization'] =
          `Bearer ${response.data['access']}`;
        window.location.href = '/'
        navigation("/");
      }
    } catch (error: any) {
      if (error.response.status === 401) {
        setSent(false);
        setClientMessage("Sorry but could not login with provided credentials");
        console.log(error.response.data);
      } else if (error.response.status === 500) {
        setSent(false);
        setClientMessage("Please try later as we are experiencing an server error. Appologies for the inconvenience.");
        console.log('500', error.response.data);
      } else {
        setSent(false);
        setClientMessage("Please try later as we are experiencing an error. Appologies for the inconvenience.");
        console.error('Error during sign up:', error);
      }
    }
  };

  const handleSubmit = (values: { [index: string]: string }) => {
    setSent(true);
    handleLogin(values.email, values.password);
  };

  return (
    <React.Fragment>
      <AppAppBar />
      <AppForm>
        <React.Fragment>
          <Typography variant="h3" gutterBottom marked="center" align="center">
            Sign In
          </Typography>
          <Typography variant="body2" align="center">
            {'Not a member yet? '}
            <Link
              href="/sign-up/"
              align="center"
              underline="always"
            >
              Sign Up here
            </Link>
          </Typography>
        </React.Fragment>
        <Form
          onSubmit={handleSubmit}
          subscription={{ submitting: true }}
          validate={validate}
        >
          {({ handleSubmit: handleSubmit2, submitting }) => (
            <Box component="form" onSubmit={handleSubmit2} noValidate sx={{ mt: 6 }}>
              <Field
                autoComplete="email"
                autoFocus
                component={RFTextField}
                disabled={submitting || sent}
                fullWidth
                label="Email"
                margin="normal"
                name="email"
                required
                size="large"
              />
              <Field
                fullWidth
                size="large"
                component={RFTextField}
                disabled={submitting || sent}
                required
                name="password"
                autoComplete="current-password"
                label="Password"
                type="password"
                margin="normal"
              />
              <FormSpy subscription={{ submitError: true }}>
                {({ submitError }) =>
                  submitError ? (
                    <FormFeedback error sx={{ mt: 2 }}>
                      {submitError}
                    </FormFeedback>
                  ) : null
                }
              </FormSpy>
              <FormButton
                sx={{ mt: 3, mb: 2 }}
                disabled={submitting || sent}
                size="large"
                color="secondary"
                fullWidth
              >
                {submitting || sent ? 'In progress…' : 'Sign In'}
              </FormButton>
            </Box>
          )}
        </Form>
        {clientMessage && (
          <Typography variant="body2" color="error" align="center">
            {clientMessage}
          </Typography>
        )}
        <Typography align="center">
          <Link underline="always" href="/forgot-password/">
            Forgot password?
          </Link>
        </Typography>
        <Snackbar
          open={open}
          closeFunc={handleClose}
          message="当サービスの利用に際しては、法人プランへのサブスクリプションが必要です。詳細はPricing Plansのページをご参照ください。"
        />
      </AppForm>
      <AppFooter />
    </React.Fragment>
  );
}

export default withRoot(SignIn);


// input={password}
// onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
//   setPassword(e.target.value);
// }}
